var map = {
	"./board/andrew-john-hunter.jpg": 679,
	"./board/andrew-john-hunter@2x.jpg": 254,
	"./board/barry-hatton.jpg": 680,
	"./board/barry-hatton@2x.jpg": 255,
	"./board/basil-scarsella.jpg": 681,
	"./board/basil-scarsella@2x.jpg": 256,
	"./board/charles-tsai.jpg": 682,
	"./board/charles-tsai@2x.jpg": 257,
	"./board/chi-tin-wan.jpg": 683,
	"./board/chi-tin-wan@2x.jpg": 258,
	"./board/chris-degg.jpg": 684,
	"./board/chris-degg@2x.jpg": 259,
	"./board/christopher-clarke.jpg": 685,
	"./board/christopher-clarke@2x.jpg": 260,
	"./board/dominic-chan.jpg": 686,
	"./board/dominic-chan@2x.jpg": 261,
	"./board/duncan-macrae.jpg": 687,
	"./board/duncan-macrae@2x.jpg": 262,
	"./board/hok-shan-chong.jpg": 688,
	"./board/hok-shan-chong@2x.jpg": 263,
	"./board/ian-smyth.jpg": 689,
	"./board/ian-smyth@2x.jpg": 264,
	"./board/ivan-chan.jpg": 690,
	"./board/ivan-chan@2x.jpg": 265,
	"./board/kam-hing-lam.jpg": 691,
	"./board/kam-hing-lam@2x.jpg": 266,
	"./board/mark-adolphus.jpg": 692,
	"./board/mark-adolphus@2x.jpg": 267,
	"./board/matt-rudling.jpg": 693,
	"./board/matt-rudling@2x.jpg": 268,
	"./board/neil-mcgee.jpg": 694,
	"./board/neil-mcgee@2x.jpg": 269,
	"./board/nirmal-kotecha.jpg": 695,
	"./board/nirmal-kotecha@2x.jpg": 270,
	"./board/patrick-clarke.jpg": 696,
	"./board/patrick-clarke@2x.jpg": 271,
	"./board/paul-jeffery.jpg": 697,
	"./board/paul-jeffery@2x.jpg": 272,
	"./board/richard-roberts.jpg": 698,
	"./board/richard-roberts@2x.jpg": 273,
	"./board/suleman-alli.jpg": 699,
	"./board/suleman-alli@2x.jpg": 274,
	"./circles/focus-1a.jpg": 700,
	"./circles/focus-1a@2x.jpg": 275,
	"./circles/focus-1b.jpg": 701,
	"./circles/focus-1b@2x.jpg": 276,
	"./circles/focus/communities-environment-1.jpg": 702,
	"./circles/focus/communities-environment-1@0,5x.jpg": 703,
	"./circles/focus/communities-environment-1@2x.jpg": 277,
	"./circles/focus/communities-environment-2.jpg": 704,
	"./circles/focus/communities-environment-2@0,5x.jpg": 705,
	"./circles/focus/communities-environment-2@2x.jpg": 278,
	"./circles/focus/customer-satisfaction-1.jpg": 706,
	"./circles/focus/customer-satisfaction-1@0,5x.jpg": 707,
	"./circles/focus/customer-satisfaction-1@2x.jpg": 279,
	"./circles/focus/customer-satisfaction-2.jpg": 708,
	"./circles/focus/customer-satisfaction-2@0,5x.jpg": 709,
	"./circles/focus/customer-satisfaction-2@2x.jpg": 280,
	"./circles/focus/innovation-1.jpg": 710,
	"./circles/focus/innovation-1@0,5x.jpg": 711,
	"./circles/focus/innovation-1@2x.jpg": 281,
	"./circles/focus/innovation-2.jpg": 712,
	"./circles/focus/innovation-2@0,5x.jpg": 713,
	"./circles/focus/innovation-2@2x.jpg": 282,
	"./circles/focus/low-carbon-readiness-1.jpg": 714,
	"./circles/focus/low-carbon-readiness-1@0,5x.jpg": 715,
	"./circles/focus/low-carbon-readiness-1@2x.jpg": 283,
	"./circles/focus/low-carbon-readiness-2.jpg": 716,
	"./circles/focus/low-carbon-readiness-2@0,5x.jpg": 717,
	"./circles/focus/low-carbon-readiness-2@2x.jpg": 284,
	"./circles/focus/network-reliability-1.jpg": 718,
	"./circles/focus/network-reliability-1@0,5x.jpg": 719,
	"./circles/focus/network-reliability-1@2x.jpg": 285,
	"./circles/focus/network-reliability-2.jpg": 720,
	"./circles/focus/network-reliability-2@0,5x.jpg": 721,
	"./circles/focus/network-reliability-2@2x.jpg": 286,
	"./circles/focus/safety-1.jpg": 722,
	"./circles/focus/safety-1@0,5x.jpg": 723,
	"./circles/focus/safety-1@2x.jpg": 287,
	"./circles/focus/safety-2.jpg": 724,
	"./circles/focus/safety-2@0,5x.jpg": 725,
	"./circles/focus/safety-2@2x.jpg": 288,
	"./circles/focus/stakeholder-engagement-1.jpg": 726,
	"./circles/focus/stakeholder-engagement-1@0,5x.jpg": 727,
	"./circles/focus/stakeholder-engagement-1@2x.jpg": 289,
	"./circles/focus/stakeholder-engagement-2.jpg": 728,
	"./circles/focus/stakeholder-engagement-2@0,5x.jpg": 729,
	"./circles/focus/stakeholder-engagement-2@2x.jpg": 290,
	"./circles/focus/value-for-money-1.jpg": 730,
	"./circles/focus/value-for-money-1@0,5x.jpg": 731,
	"./circles/focus/value-for-money-1@2x.jpg": 291,
	"./circles/focus/value-for-money-2.jpg": 732,
	"./circles/focus/value-for-money-2@0,5x.jpg": 733,
	"./circles/focus/value-for-money-2@2x.jpg": 292,
	"./circles/hero-1a.jpg": 734,
	"./circles/hero-1a@2x.jpg": 293,
	"./circles/hero-1b.jpg": 735,
	"./circles/hero-1b@2x.jpg": 294,
	"./people/black-asian-ethnic.jpg": 764,
	"./people/black-asian-ethnic@0,5x.jpg": 765,
	"./people/black-asian-ethnic@2x.jpg": 348,
	"./people/case-study-2.jpg": 766,
	"./people/case-study-2@0,5x.jpg": 767,
	"./people/case-study-2@2x.jpg": 349,
	"./people/case-study.jpg": 768,
	"./people/case-study@0,5x.jpg": 769,
	"./people/case-study@2x.jpg": 350,
	"./people/resilience.jpg": 770,
	"./people/resilience@0,5x.jpg": 771,
	"./people/resilience@2x.jpg": 351,
	"./people/trailblazers.jpg": 772,
	"./people/trailblazers@0,5x.jpg": 773,
	"./people/trailblazers@2x.jpg": 352,
	"./people/women.jpg": 774,
	"./people/women@0,5x.jpg": 775,
	"./people/women@2x.jpg": 353,
	"./video-final-frame.jpg": 799,
	"./video-final-frame@2x.jpg": 366
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 861;


//////////////////
// WEBPACK FOOTER
// ./src/assets/images ^\.\/.*\.jpg$
// module id = 861
// module chunks = 0